import PropTypes from 'prop-types';

import classNames from 'classnames';

// Styles
import './InfoBox.scss';

const InfoBox = ({ title = '', content = '', className = '' }) => {
  const classValue = classNames('infobox__title', className);

  return (
    <div className="infobox">
      <h3 className={classValue}>{title}</h3>
      <ul className="infobox__content">
        <li>{content}</li>
      </ul>
    </div>
  );
};

InfoBox.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string
};

export default InfoBox;
